export const InterfaceResourceStrategies = {
  Standard: 'standard',
  Deployed: 'deployed',
  Authorization: 'authorization',
  DeployedByVersion: 'DeployedByVersion',
  NativePreview: 'nativePreview',
  CachedResources: 'cachedResources',
  SavedByVersion: 'SavedByVersion',
} as const;

export type InterfaceResourceStrategyType =
  (typeof InterfaceResourceStrategies)[keyof typeof InterfaceResourceStrategies];
